import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Bank} from './bank';

@Injectable()
export class BankService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('banks?' + params.toString()).map((response: Response) => response.json());
  }

  getById(_id: string) {
    return this.http.get('banks/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('banks/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('banks/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(bank: Bank) {
    return this.http.post('banks', bank).map((response: Response) => response.json());
  }

  update(bank: Bank) {
    return this.http.put('banks/' + bank.id, bank).map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('banks/' + _id);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/banks/bank.service.ts